import React from 'react';
import PropTypes from 'prop-types';
import Notifications from './Global/Notifications/Notifications';

const App = props => (
  <div className="app-child-routes">
    {props.children}
    <Notifications />
  </div>
);

App.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default App;



// WEBPACK FOOTER //
// ./library/app/components/App.js